import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify, type ResourcesConfig } from 'aws-amplify';
import { sessionStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import amplifyconfig from './amplifyconfiguration.json';

const authConfig: ResourcesConfig['Auth'] = {
    Cognito: {
        userPoolId: 'us-west-2_JGGploGsn',
        userPoolClientId: '7pfmlsrbaco27ip4adkguf2pe5',
    }
};

Amplify.configure( {
    Auth: authConfig
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

localStorage.setItem('baseURL', 'https://apajauvdeaohd6tbqfsejblhdq0hmayq.lambda-url.us-west-2.on.aws/');
//localStorage.setItem('baseURL', 'https://localhost:49505/');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
